<template>
  <div
    class="navbar-wrapper"
    :class="{active: menuOpened}"
  >
    <div class="loading-spinner" v-if="isLoading">
    </div>
    <router-link to="/" class="logo">
      <img
        src="../assets/logo.svg"
        alt="logo"
      >
    </router-link>
    <div
      class="menu"
      :class="{active: menuOpened}"
    >
      <button
        class="nav-tgl"
        :class="{opened: menuOpened}"
        @click="buttonAnimate"
      >
        <span />
      </button>
      <nav class="nav">
        <div class="bg">
          <ul class="menu-items">
            <li @click="buttonAnimate">
              <router-link to="/">
                Главная
              </router-link>
            </li>
            <li @click="buttonAnimate">
              <router-link to="/feedback">
                Форма обратной связи
              </router-link>
            </li>
            <li @click="buttonAnimate">
              <router-link to="/contacts">
                Контакты
              </router-link>
            </li>
            <li />
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Navbar',
  data () {
    return {
      menuOpened: false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.goods.isLoading
    })
  },
  methods: {
    buttonAnimate () {
      this.menuOpened = !this.menuOpened
    }
  }
}

</script>

<style scoped lang="scss">
  @import "../vars.scss";

  .navbar-wrapper {
    height: $navbar-height;
    padding: 0 15%;
    background-color: #FFF;
    box-shadow: 0 0 2px 1px #aaa;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 3;
    position: relative;

    .loading-spinner {
      position: absolute;
      bottom: -5px;
      height: 5px;
      background-color: $btn-c;
      animation: loadingAnimation 2s ease infinite;
    }
    @keyframes loadingAnimation {
      0% {
        left: 0;
        width: 0;
      }
      50% {
        left: 0;
        width: 100%;
      }
      75% {
        left: unset;
        right: 0;
        width: 100%;
      }
      100% {
        left: unset;
        right: 0;
        width: 0;
      }
    }
    &.active {
      z-index: 5;
    }
    .logo {
      height: 100%;
      width: 100px;
      display: flex;
      align-items: center;
      position: absolute;
      /*left: calc(20% - 50px);*/
      img {
        max-height: 30%;
      }
    }

    .menu {
      width: 30px;
      z-index: 3;
      position: absolute;
      right: calc(20% - 15px);
    }

    .nav {
      ul {
        transition: opacity .1s ease;
        transition-delay: .5s;
        padding: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        li {
          padding: 30px 0;
          font-size: 36px;
        }
      }
      .menu-items {
        position: absolute;
        list-style-type: none;
        top: 47%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 32px;
        z-index: 5;
        li {
          cursor: pointer;
          a {
            text-decoration: none;
            color: $tc;
            font-weight: bold;
            display: inline-block;
            overflow: hidden;
            position: relative;
            padding: 5px 0;
            &:before {
              position: absolute;
              content: '';
              display: inline-block;
              height: 5px;
              width: 50px;
              background-color: $btn-c;
              top: 0;
              left: -50px;
              transition: left 0.3s ease;
            }
            &:hover {
              &:before {
                left: 0;
              }
            }
            &:visited {
              color: $tc;
            }
          }
        }
      }
    }

    .nav-tgl {
      display: inline-block;
      cursor: pointer;
      z-index: 100;
      width: 30px;
      height: 30px;
      border: none;
      border-radius: 50%;
      padding: 5px;
      background: #fff;
      box-shadow: 0px 1px 7px -1px rgba(0, 0, 0, 0.24);
      line-height: 0.6;
      text-align: center;
      position: relative;

      > span {
        display: inline-block;
        position: relative;
        height: 1px;
        width: 80%;
        border-radius: 1px;
        background: #293335;
        vertical-align: middle;

        &:before, &:after {
          display: inline-block;
          position: absolute;
          content: "";
          height: 1px;
          border-radius: 1px;
          background: #293335;
          transition: all 200ms;
        }
        &:before {
          top: -7px;
          left: 3px;
          width: 60%;
        }
        &:after {
          top: 7px;
          left: 4px;
          width: 50%;
        }
      }

      &:focus {outline: none}

      &:hover > span:after, &:hover > span:before {
        width: 100%;
        left: 0;
        right: 0;
      }
    }

    .nav .bg {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      content: '';
      width: 100vw;
      height: 100vh;
      /*background: #2e2e2e;*/
      background-image: url("../assets/BG1.png");
      background-position: center;
      background-size: contain;
      transition: all 500ms ease-in-out, z-index 2s ease;
      z-index: 4;
      clip-path: circle(15px at 80% 30px);
      visibility: hidden;
    }

    .menu.active {
      z-index: 999;
      .nav .bg {
        visibility: visible;
        clip-path: circle(100%);
      }
      .nav {
        ul {
        }
      }

      .nav-tgl > span {
        height: 0;
        &:after, &:before {
          top: 0;
          left: 0;
          width: 100%;
        }
        &:after {
          transform: rotate(-45deg);
        }
        &:before {
          transform: rotate(45deg);
        }
      }
    }
  }
  @media screen and (max-width: 550px){
    .navbar-wrapper {
      padding: 0 10%;
      .menu {
        right: calc(16% - 15px);
      }
      .nav {
        ul {
          width: 80%;
          li {
            a {
              font-size: 24px;
            }
          }
        }
      }
    }
  }
</style>
